import type { SignatureRequestsResponse } from './types';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { type UUID } from '~/types/common';

import { queryKeysDeliveryNote } from '../queryKeys';

import { fetchSignatureRequests } from './fetchSignatureRequests';

/**
 * React Query based custom hook for fetching signature requests for a delivery note.
 *
 * @param deliveryNoteId - The ID of the delivery note.
 * @param options - Additional options for the useQuery hook.
 * @returns The result of the useQuery hook.
 */
export const useQuerySignatureRequests = (
  deliveryNoteId: UUID,
  options?: Omit<
    UseQueryOptions<SignatureRequestsResponse>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery<SignatureRequestsResponse>({
    enabled: Boolean(deliveryNoteId),
    queryFn: async () => fetchSignatureRequests(deliveryNoteId),
    queryKey: queryKeysDeliveryNote.getSignatureRequests(deliveryNoteId),
    ...options,
    refetchOnWindowFocus: false,
  });
};
